import { FC, lazy, Suspense } from 'react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { BrowserRouter } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import authClient from '../auth/client';

const App = lazy(() => import('../App'));

const AppRouter: FC = () => {
  const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
    window.location.replace(
      toRelativeUrl(originalUri || '/', window.location.origin),
    );
  };

  return (
    <BrowserRouter>
      <Security oktaAuth={authClient} restoreOriginalUri={restoreOriginalUri}>
        <Suspense fallback={null}>
          <App />
        </Suspense>
      </Security>
    </BrowserRouter>
  );
};

export default AppRouter;
